<template>
  <svg height="24" width="24" viewBox="0 0 24 24" version="1.1" xmlns:svgjs="http://svgjs.com/svgjs" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" class=""><g xmlns="http://www.w3.org/2000/svg" transform="matrix(1,0,0,1,0,0)"><path d="M0,12c0,0.828,0.672,1.5,1.5,1.5h8.75c0.138,0,0.25,0.112,0.25,0.25v8.75c0,0.828,0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5 v-8.75c0-0.138,0.112-0.25,0.25-0.25h8.75c0.828,0,1.5-0.672,1.5-1.5s-0.672-1.5-1.5-1.5h-8.75c-0.138,0-0.25-0.112-0.25-0.25V1.5 C13.5,0.672,12.828,0,12,0s-1.5,0.672-1.5,1.5v8.75c0,0.138-0.112,0.25-0.25,0.25H1.5C0.672,10.5,0,11.172,0,12z" stroke="none" fill="currentColor" stroke-width="0" stroke-linecap="round" stroke-linejoin="round"></path></g></svg>
</template>

<script>
export default {
  name: "PlusIcon"
}
</script>
